var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.0001 0C14.7891 0 10.5527 4.26002 10.5527 9.50005C10.5527 14.6401 14.5505 18.8001 19.7614 18.9801C19.9205 18.9601 20.0797 18.9601 20.199 18.9801C20.2388 18.9801 20.2587 18.9801 20.2984 18.9801C20.3183 18.9801 20.3183 18.9801 20.3382 18.9801C25.4299 18.8001 29.4276 14.6401 29.4475 9.50005C29.4475 4.26002 25.2111 0 20.0001 0Z",
    fill: "#FFFCFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1056 24.2998C24.5565 20.5798 15.507 20.5798 9.91817 24.2998C7.39224 25.9998 6 28.2998 6 30.7598C6 33.2198 7.39224 35.4998 9.89828 37.1799C12.6828 39.0599 16.3423 39.9999 20.0019 39.9999C23.6615 39.9999 27.3211 39.0599 30.1056 37.1799C32.6117 35.4798 34.0039 33.1998 34.0039 30.7198C33.984 28.2598 32.6117 25.9798 30.1056 24.2998Z",
    fill: "#FFFCFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8665c3f752d921f5ad7ff2ab7645aac3.svg";
export { ForwardRef as ReactComponent };